<template>
 <vs-popup class="user-preferences-popup" button-close-hidden title="" :active="popupActive">
  <div class="flex justify-center">
    <div class="md:w-3/4 w-full">
      <div class="flex items-center justify-center">
        <img src="@/assets/images/helpus.png" alt="Image" class="md:w-96 w-64 mx-auto mb-4">
      </div>

        <h3 class="text-center font-bold mt-2" style="color: #FFB800">FEEDBACK</h3>
        <h1 class="text-center font-bold mt-2" style="font-size: 3rem;">help us help you</h1>

      <h5 class="mt-4 mb-1 text-center">How is it going so far? Is there anything you miss or don't like about improvee.io?</h5>

      <div class="flex justify-evenly mt-2">
        <vs-button color="#FFB800" type="flat" @click="everythingIsFine" >
          Everything is fine!
        </vs-button>

        <vs-button color="#FFB800" type="flat" @click="askMeLater" >
          I don't know, ask me later.
        </vs-button>
      </div>

      <vs-textarea class="mt-4 mb-1" placeholder="Do you need help with something? Let us know." v-model="whatDoYouMiss" />
      <div class="flex justify-evenly">
        <vs-button color="#FFB800" icon="icon-send" icon-pack="feather" @click="save" >
          send request
        </vs-button>
      </div>
    </div>
  </div>

  </vs-popup>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    forceOpen: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  data () {
    return {
      popupActive: false,
      whatDoYouMiss: '',
    }
  },
  async mounted () {
    this.whatDoYouMiss = this.user.whatDoYouMiss
    // this.level = this.userPreferences['level'] || []
    // this.whatAreYouTryingToSolve = this.savedWhatAreYouTryingToSolve
    this.popupActive = this.forceOpen || this.showWithoutAsking
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    showWithoutAsking () {
      return this.$store.getters.onboardingTourFinished &&
      _.isEmpty(this.user.whatDoYouMiss) &&
      this.$store.getters.atLeastVisits(15) &&
      !this.$store.getters.hasMembershipExpired
    },
  },
  methods: {
    save () {
      // const wannaHelpWith = this.wannaHelpWith
      // const level = this.level
      const whatDoYouMiss = this.whatDoYouMiss

      const user = Object.assign({}, this.$store.getters.user)

      user.whatDoYouMiss = whatDoYouMiss

      console.log(user)

      this.$store.dispatch('UPDATE_USER', { user })
      this.popupActive = false
    },
    everythingIsFine () {
      const user = Object.assign({}, this.$store.getters.user)

      user.whatDoYouMiss = 'everything is fine'

      console.log(user)

      this.$store.dispatch('UPDATE_USER', { user })
      this.popupActive = false
    },
    askMeLater () {
      const user = Object.assign({}, this.$store.getters.user)

      user.whatDoYouMiss = 'ask me later'

      console.log(user)

      this.$store.dispatch('UPDATE_USER', { user })
      this.popupActive = false
    }
  }
}
</script>

<style land="scss">

  .vs-popup--header {
    border-radius: 2rem;
  }

  .vs-popup--title {
    background: #ffffff;
    border-radius: 2rem;
  }


  .vs-popup {
    border-radius: 2rem
  }


 .user-preferences-popup .vs-popup--header {
    display: none;
  }
</style>
